// 選択できる年数: 今年 + 100年で101
export const SELECT_BIRTH_YEARS = 101;
export const SELECT_BIRTH_MONTHS = 12;
export const SELECT_BIRTH_DAYS = 31;
// 性別未選択
export const NOT_SELECTED_GENDER = 0;
